const playback = {
  path: 'playback',
  component: resolve => require(['../../../../pages/teacher/videoplay/playback'], resolve)
}

export default playback



// WEBPACK FOOTER //
// ./src/router/teacher/videoplay/playback/index.js